module.exports = __webpack_public_path__ + "img/IMG_8673_L.92bf6aca.webp";